'use client';
import React from "react"
import { lazy } from "react";
import { useEffect, useState } from "react";
import StandingService from "@/services/standingService";
import { Image, isNextBuild } from '@/lib/target';
import { BXH_LEAGUES } from "@/contants";
import { LeaguesDropdown } from "@/components/client/LeagueStanding/index.js"
import { useIsMobile } from "@/lib/isMobile";
const BreadcrumbStanding = lazy(() => import('@/components/client/BreadcrumbStanding'));
const StandingHeader = lazy(() => import('@/components/client/StandingHeader'));
const NoData = lazy(() => import('@/components/client/NoData'));

const TopScorers = ({params, league}) => {

  let leagueId = league;
  if(isNextBuild) {
    const activeLeague = params.slug;
    leagueId = BXH_LEAGUES.find((league) => league.slug === activeLeague).id;
  }  
  
  const [activeTabList, setActiveTabList] = useState(leagueId);
  const [data, setData] = useState([]);
  const [selectedSeason, setSelectedSeason] = useState('2024-2025');
  const [visibleItems, setVisibleItems] = useState(20);
  const handleSelectSeason = (season) => {
    setSelectedSeason(season);
  };
    
  const fetchData = async () => {
    if (activeTabList) {
      try {
        const { data: { result } } = await StandingService.getTopScorers(activeTabList, selectedSeason);
        setData(result);
      } catch (error) {
        console.error("Error fetching standings:", error);
      }
    }
  };

  useEffect(() => {
    fetchData();
    setVisibleItems(20);
  }, [activeTabList]);

  useEffect(() => {
    fetchData();
  }, [selectedSeason]);  

  return (
    <div className="standing-list rounded w-full mx-auto @md:px-2">
      {isNextBuild && <StandingHeader title="Top Ghi Bàn" type={'top-ghi-ban'} leagues={BXH_LEAGUES}/>}

      <div className="pl-2 mt-2"><BreadcrumbStanding className="@md:flex hidden"/></div>
      <SeasonDropdown seasons={[
        '2024-2025',
        '2023-2024',
        '2022-2023',
        '2021-2022',
        '2020-2021',
        '2019-2020',
        ]} 
        onSelect={handleSelectSeason}
        setSelectedSeason={setSelectedSeason}
        selectedSeason={selectedSeason}
        />
      <div id="tab-contents px-7">
        <TopScorersItem data={data} visibleItems={visibleItems} setVisibleItems={setVisibleItems}/>
      </div>
    </div>
  );
};

const TopScorersItem = ({data, visibleItems, setVisibleItems}) => {
  if (!data || data.length === 0) {
    return <NoData />;
  }

  return (
    <div className="text-center px-2 @md:px-7 pb-7 !text-xxs @md:!text-xs">
      <div className="flex w-full grow justify-between h-7 bg-stroke-o3 dark:bg-midnight-slate rounded">
        <div className="w-8 mr-2 pl-2 @md:mr-5 flex items-center justify-center">#</div>
        <div className="w-96 text-left flex items-center justify-start">Đội bóng</div>
        <div className="flex w-60 justify-between">
          <div className="w-full flex items-center justify-center">Cầu Thủ</div>
        </div>
        <div className="flex w-20 @md:w-60 justify-between">
          <div className="w-full flex items-center justify-center">
            <span className="hidden @md:flex">Tổng Ghi Bàn</span>
            <span className="@md:hidden">TGB</span>
          </div>
        </div>
        <div className="w-16 @md:w-44 flex items-center justify-center">
          <span className="hidden @md:flex">Số Bàn Penlaty</span>
          <span className="@md:hidden">Pen</span>
        </div>
      </div>
      {data.sort((a, b) => b.goalsCount - a.goalsCount).slice(0, visibleItems).map((item, index) => (
        <div key={item.name} className="flex w-full grow justify-between h-8 even:bg-header-blue dark:even:bg-dark-slate dark:odd:bg-midnight-slate items-center text-dark-gray dark:text-white">
          <div className="w-8 pl-2 mr-2 @md:mr-5">{index + 1}</div>
          <div className="w-96 text-left flex">
            <Image alt="Net88" src={item.teams.logo || 'https://demofree.sirv.com/nope-not-here.jpg'} width={20} height={20} />
            <span className="ml-2">{item.teams.name}</span>
          </div>
          <div className="flex w-60 justify-between @md:justify-center">
            <div className="w-full text-button-blue-bet font-bold max-w-[90px] @md:max-w-full truncate text-center">{item.playerName}</div>
          </div>
          <div className="flex w-20 @md:w-60 justify-between">
            <div className="w-full font-bold">{item.goalsCount}</div>
          </div>
          <div className="w-16 @md:w-44 font-bold">{item.homePenalty + item.awayPenalty}</div>
        </div>
      ))}
      {visibleItems < data.length && (
        <button
          onClick={() => setVisibleItems(visibleItems + 20)}
          className="mt-4 p-2 bg-gradient-start text-dark-gray rounded uppercase hover:text-white hover:bg-gradient-end"
        >
          {`(${visibleItems}/${data.length}) Xem thêm +20`}
        </button>
      )}
    </div>
  );
};

const SeasonDropdown = ({ seasons, onSelect, selectedSeason, setSelectedSeason }) => {
  const isMobile = useIsMobile();
  const handleSelect = (value) => {
    setSelectedSeason(value);
    if (onSelect) {
      onSelect(value);
    }
  };

  return (
    <div className="hidden font-montserrat font-semi-bold flex gap-2 items-center my-4 mt-0 px-2 @md:px-7">

      <label htmlFor="season-dropdown" className="w-1/5 @md:w-auto dark:text-stroke-o3">
        Mùa giải:
      </label>
      {isNextBuild && isMobile ? (<LeaguesDropdown items={seasons} itemId={selectedSeason} type="season" handlerFunc={handleSelect} />) : (<select
        id="season-dropdown"
        className="p-2 rounded shadow-md w-4/5 @md:w-32 text-center"
        value={selectedSeason}
        onChange={handleSelect}
      >
        {seasons.map((season, index) => (
          <option key={index} value={season}>
            {season}
          </option>
        ))}
      </select>)}


    </div>
  );
};

export default React.memo(TopScorers);